// extracted by mini-css-extract-plugin
module.exports = {"heading":"Holdings-module__heading--1Ce0_"};